import { Platform, StyleSheet } from 'react-native';
import Theme from '../../theme';

const styles = StyleSheet.create({
    headingContainer: {
        paddingBottom: 20,
        paddingLeft: 20
    },
    header: {
        color: Theme.CHARCOAL,
    },
    invertedHeader: {
        fontSize: 16,
        fontFamily:Theme.Custom500,
        paddingVertical: 5,
        color: Platform.OS === 'web' ? Theme.GREY_LIGHT : Theme.CHARCOAL,
    },
});

export default styles;
